import { piwikPush } from './PiwikPush';
import { AnalyticsItem, AnalyticsItemsEvent } from '../CombinedGAPiwik';

export type PiwikProduct = {
   sku: string;
   name?: string;
   quantity?: number;
   price: number;
};

export const trackPiwikAddToCart = (items: AnalyticsItem[]) => {
   piwikPush(['ecommerceAddToCart', formatAnalyticsItemToPiwikProducts(items)]);
};

export const trackPiwikRemoveFromCart = (items: AnalyticsItem[]) => {
   piwikPush(['ecommerceRemoveFromCart', formatAnalyticsItemToPiwikProducts(items)]);
};

export const trackPiwikCartUpdate = (event: AnalyticsItemsEvent) => {
   piwikPush(['ecommerceCartUpdate', formatAnalyticsItemToPiwikProducts(event.items), event.value]);
};

function formatAnalyticsItemToPiwikProducts(products: AnalyticsItem[]): PiwikProduct[] {
   const formattedProducts = products.map(product => {
      const formattedProduct = {
         sku: product.item_id,
         name: product.item_name,
         quantity: product.quantity,
         price: product.price,
      };
      return removeEmptyKeyValuePairs(formattedProduct) as PiwikProduct;
   });
   return formattedProducts;
}

function removeEmptyKeyValuePairs(obj: any) {
   return Object.fromEntries(Object.entries(obj).filter(([, value]) => value != null));
}
